import React from 'react';
import { Checkins } from '../Checkins';
export const BlockCheckins = ({ lines }) => (React.createElement(Checkins, { lines: lines }));



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockCheckins.tsx
// module id = 513
// module chunks = 0